var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStandarIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_396_1864)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 0.04737C33.9986 0.235483 33.1132 0.948327 32.6312 1.92849C32.4049 2.38392 32.4049 2.42353 32.3754 7.26495C32.3557 11.6311 32.336 12.146 32.1983 12.0965C32.1098 12.0668 31.854 12.0371 31.6179 12.0371H31.1949L31.1555 10.8193C31.126 9.73021 31.0867 9.5421 30.8407 9.02727C30.5456 8.43323 30.0144 7.9481 29.3749 7.71048C29.1782 7.64118 28.3912 7.59167 27.3189 7.59167L25.5678 7.58177V5.15611V2.72055L25.3219 2.48293C24.9874 2.13641 24.2791 2.13641 23.9446 2.48293L23.6987 2.72055V5.15611V7.58177H22.0066C21.0721 7.58177 20.1375 7.63127 19.9408 7.68078C19.38 7.83919 18.7603 8.37383 18.4356 8.96786C18.1602 9.4728 18.1405 9.59161 18.111 10.7599L18.0716 12.0074L17.4125 12.0569C16.4091 12.1361 15.7205 12.5717 15.2581 13.4628L14.9925 13.9677L14.963 17.1557L14.9335 20.3437L10.241 20.3734L5.54849 20.4031L4.98775 20.6803C4.35815 20.9972 3.89578 21.4724 3.59082 22.1258C3.38423 22.5813 3.38423 22.6209 3.35472 34.2839L3.33504 45.9963H2.02666C0.915016 45.9963 0.678916 46.026 0.413303 46.1944C-0.147436 46.531 -0.137598 47.4616 0.442815 47.7983C0.708428 47.9468 2.36113 47.9666 24.043 47.9864C49.1975 48.0161 47.653 48.0458 47.8891 47.5111C48.0859 47.0854 48.017 46.6993 47.7121 46.3825L47.4268 46.0953H46.0299H44.6329L44.6624 24.2941L44.7018 2.48293L44.4362 1.91859C44.0919 1.16614 43.4131 0.522601 42.7146 0.255283C42.2129 0.0671708 41.9178 0.0473675 38.8091 0.00776482C36.9695 -0.0120365 35.2479 0.00776731 34.9922 0.04737ZM41.9965 2.11661C42.1834 2.20571 42.4392 2.43343 42.5572 2.62154L42.7835 2.95816V20.1457C42.7835 29.6008 42.754 39.3035 42.7146 41.7094L42.6556 46.0953H38.4255H34.1953L34.2642 24.4921C34.3331 0.463197 34.2642 2.58194 35.002 2.14631C35.3365 1.94829 35.4939 1.93839 38.5042 1.93839C41.3079 1.93839 41.6915 1.9582 41.9965 2.11661ZM28.9814 9.80942C29.188 10.0371 29.2077 10.1658 29.2077 11.0569V12.0371H24.6333H20.0588V11.0173C20.0687 9.94803 20.1277 9.75002 20.5605 9.5619C20.7179 9.4926 22.1444 9.4728 24.7808 9.5025L28.7552 9.5421L28.9814 9.80942ZM26.5221 14.0172H31.8737L32.1098 14.2647L32.3557 14.5023V21.908C32.3557 25.9772 32.3262 33.0859 32.2869 37.6996L32.2278 46.0953H30.2702H28.3223V43.2836V40.4817L28.0666 40.2144L27.8009 39.9569H24.5644H21.3279L21.0918 40.2045L20.8458 40.4421V43.2242V45.9963H18.8488H16.842L16.8911 30.2246C16.9305 15.8191 16.9502 14.4429 17.0977 14.2746C17.383 13.9479 17.6191 13.9182 19.4095 13.9677C20.3835 13.9974 23.5807 14.0172 26.5221 14.0172ZM14.9433 34.165V45.9963H10.1229H5.30255V34.5017V23.007L5.63702 22.6704L5.9715 22.3338H10.4574H14.9433V34.165ZM26.3548 43.9667V46.0953H24.5349H22.7149V43.9667V41.8381H24.5349H26.3548V43.9667Z",
    fill: "url(#paint0_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8542 9.42262L37.6181 9.68003L37.5689 23.7984C37.5394 31.5704 37.5591 38.0652 37.5984 38.2434C37.6968 38.6593 38.0017 38.8672 38.5035 38.8672C38.8183 38.8672 38.9658 38.8078 39.1626 38.5999L39.4183 38.3227L39.4774 24.1449C39.5462 11.3532 39.5364 9.94735 39.3987 9.67013C39.2019 9.29391 38.9658 9.1652 38.4739 9.1652C38.1887 9.1652 38.0313 9.2345 37.8542 9.42262Z",
    fill: "url(#paint1_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7567 19.5604C19.3524 19.8854 19.2611 20.2814 19.522 20.7181C19.7567 21.1242 20.2131 21.2461 21.5433 21.2461C22.6387 21.2461 22.7822 21.2258 23.0821 21.0024C23.2647 20.8704 23.4473 20.6368 23.4864 20.4845C23.5907 20.1291 23.2777 19.5198 22.9256 19.3777C22.7691 19.3167 22.091 19.266 21.3998 19.266C20.187 19.266 20.1218 19.2761 19.7567 19.5604Z",
    fill: "url(#paint2_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1387 19.5531C25.8685 19.7709 25.7656 19.9392 25.7656 20.2065C25.7656 20.959 26.3317 21.2461 27.8112 21.2461C28.879 21.2461 29.2778 21.1471 29.5737 20.7907C29.934 20.3748 29.8568 19.8699 29.3808 19.5432C28.9948 19.2858 28.9047 19.266 27.7469 19.266C26.5633 19.266 26.4989 19.2759 26.1387 19.5531Z",
    fill: "url(#paint3_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.091 25.829C19.302 26.0877 19.131 26.9135 19.7491 27.3911C20.1173 27.6697 20.1831 27.6797 21.3404 27.6797C22.1425 27.6797 22.6554 27.6299 22.9184 27.5304C23.7864 27.1921 23.668 26.1275 22.7343 25.839C22.1557 25.6599 20.6302 25.6499 20.091 25.829Z",
    fill: "url(#paint4_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1076 26.0461C25.6309 26.4025 25.6567 27.0064 26.1592 27.3926C26.5328 27.6698 26.5715 27.6797 27.8212 27.6797C29.0323 27.6797 29.1225 27.6698 29.4446 27.4223C29.9085 27.0559 29.9213 26.3926 29.4575 26.0461C29.1612 25.8184 29.0581 25.7986 27.7826 25.7986C26.507 25.7986 26.404 25.8184 26.1076 26.0461Z",
    fill: "url(#paint5_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7523 32.5228C19.4531 32.7513 19.375 32.9003 19.375 33.2282C19.375 34.0031 20.0906 34.2813 21.8601 34.2018C22.6798 34.172 22.8229 34.1322 23.0961 33.8938C23.3173 33.6951 23.4084 33.4964 23.4084 33.1785C23.4084 32.8209 23.3433 32.7116 23.005 32.493C22.6407 32.2546 22.5106 32.2347 21.3657 32.2347C20.1817 32.2347 20.1166 32.2446 19.7523 32.5228Z",
    fill: "url(#paint6_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1528 32.5292C25.6614 32.9252 25.6355 33.5142 26.0881 33.9305C26.3985 34.2047 26.4244 34.2148 27.7823 34.2148C29.1402 34.2148 29.1661 34.2047 29.4765 33.9305C29.9291 33.5142 29.9033 32.9252 29.4118 32.5292C29.0368 32.2449 28.9851 32.2347 27.7823 32.2347C26.5796 32.2347 26.5278 32.2449 26.1528 32.5292Z",
    fill: "url(#paint7_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.70343 26.7082C7.58538 26.7379 7.36895 26.8963 7.22139 27.0745C7.00497 27.3319 6.97545 27.4507 7.0148 27.7774C7.05415 28.0448 7.16237 28.2626 7.3296 28.4012C7.58538 28.6289 7.63457 28.6289 10.1431 28.6289H12.7009L12.937 28.3913C13.3797 27.9359 13.36 27.2824 12.878 26.926C12.6714 26.7775 12.3467 26.7478 10.2809 26.7082C8.98231 26.6785 7.82148 26.6884 7.70343 26.7082Z",
    fill: "url(#paint8_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4076 32.3351C7.03377 32.5628 6.89605 33.0677 7.08296 33.533C7.30922 34.0776 7.51581 34.1172 10.1719 34.1172H12.592L12.9068 33.8301C13.1724 33.5925 13.2314 33.4736 13.2314 33.1271C13.2314 32.7806 13.1724 32.6618 12.9068 32.4242L12.592 32.1371H10.1523C7.91915 32.1371 7.69289 32.1569 7.4076 32.3351Z",
    fill: "url(#paint9_linear_396_1864)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.26146 37.8668C6.8778 38.2628 6.86796 38.7479 7.25163 39.1539L7.51724 39.4509L10.0258 39.4806C12.2884 39.5103 12.5639 39.4905 12.8098 39.3321C13.3017 39.0153 13.3214 38.1242 12.8492 37.7579C12.6623 37.5995 12.3475 37.5797 10.0947 37.5797H7.54675L7.26146 37.8668Z",
    fill: "url(#paint10_linear_396_1864)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_1864",
    x1: 0.210907,
    y1: 23.9698,
    x2: 48,
    y2: 23.9698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_1864",
    x1: 37.5633,
    y1: 23.9975,
    x2: 39.5191,
    y2: 23.9975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_1864",
    x1: 19.3932,
    y1: 20.2548,
    x2: 23.5068,
    y2: 20.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_1864",
    x1: 25.7833,
    y1: 20.2548,
    x2: 29.799,
    y2: 20.2548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_1864",
    x1: 19.3932,
    y1: 26.6884,
    x2: 23.5068,
    y2: 26.6884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_1864",
    x1: 25.7833,
    y1: 26.7379,
    x2: 29.799,
    y2: 26.7379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_396_1864",
    x1: 19.3927,
    y1: 33.2235,
    x2: 23.4084,
    y2: 33.2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_396_1864",
    x1: 25.7833,
    y1: 33.2235,
    x2: 29.799,
    y2: 33.2235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_396_1864",
    x1: 7.02748,
    y1: 27.658,
    x2: 13.2549,
    y2: 27.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_396_1864",
    x1: 7.02738,
    y1: 33.1259,
    x2: 13.2314,
    y2: 33.1259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_396_1864",
    x1: 6.99609,
    y1: 38.5347,
    x2: 13.1914,
    y2: 38.5347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C8FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.343347,
    stopColor: "#5C8EF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.667816,
    stopColor: "#7E8DF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9B8DF2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_396_1864"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandarIcon3);
export default __webpack_public_path__ + "static/media/standar-icon-3.ea0fa68db0ffb0d8058749ad061d969e.svg";
export { ForwardRef as ReactComponent };